(() => {
  const root = document.querySelector('[data-monolith-advisors]');
  if (!root) return;
  const translations = {
  "de": {
    "o": [
      "Bestellbestätigung fehlt",
      "Hausnummer oder Adresszusatz fehlt",
      "Paket kommt zurück",
      "Rechnung anfragen"
    ],
    "g": [
      "Prüfe Spamordner und Kundenkonto. Mit der beim Kauf verwendeten E-Mail und dem ungefähren Datum können wir deine Anfrage prüfen. Falls du bereits bezahlt hast, kannst du auch unsere Zahlungshilfe nutzen.",
      "Nenne die fehlende Hausnummer oder den Adresszusatz und die vollständige richtige Lieferadresse. Wir prüfen, ob eine Korrektur noch möglich ist. Sie gilt erst nach unserer Bestätigung; die Anfrage stoppt den Versand nicht automatisch.",
      "Notiere die Rücksendemeldung im Tracking und den genannten Grund, falls bekannt. Wir prüfen den tatsächlichen Stand und den nächsten Schritt. Ein Neuversand oder eine Erstattung wird damit noch nicht zugesagt.",
      "Gib die Bestellung und die gewünschten Rechnungsangaben an. Wir prüfen deine Anfrage; eine Änderung der ursprünglichen Rechnungsdaten ist damit noch nicht bestätigt."
    ],
    "f": [
      "Beim Kauf verwendete E-Mail-Adresse (falls abweichend)",
      "Ungefähres Bestelldatum (falls bekannt)",
      "Rücksendegrund laut Tracking (falls bekannt)",
      "Gewünschte Rechnungsangaben (optional)",
      "Firma / USt-ID (falls relevant)",
      "Marke des Wunschprodukts (optional)",
      "Wir sammeln deinen Wunsch für unser Sortiment. Damit ist noch keine Beschaffung oder Verfügbarkeit zugesagt."
    ],
    "u": [
      "Produkt finden",
      "Produktname oder Marke",
      "Im Shop suchen",
      "Hilfe schnell finden",
      "Zum Beispiel: Adresse, Pinsel, Rechnung",
      "Kein passendes Thema gefunden. Wähle unten die Produkt- oder Bestellhilfe.",
      "Gib mindestens zwei Zeichen ein.",
      "Geschenk nach Budget finden",
      "Dein maximales Budget",
      "Ich prüfe verfügbare E-CARD-Stufen …",
      "Aktuell ist keine verfügbare E-CARD-Stufe innerhalb dieses Budgets hinterlegt.",
      "Passende E-CARD ansehen",
      "Produkte im Budget ansehen",
      "Beauty-Geschenk über Farben finden",
      "Geschenk direkt verschicken",
      "Lieferadresse: vollständiger Name, Strasse, Hausnummer, Postleitzahl, Ort und Land der beschenkten Person.",
      "Gutscheinart wählen: digitale E-CARD per E-Mail oder physischer Gutschein für den Postversand.",
      "Persönliche Nachricht: prüfe, ob das gewählte Produkt oder der Checkout dafür ein Feld anbietet.",
      "Prüfe vor dem Bezahlen Empfänger, Versandkosten und die angezeigten Lieferhinweise.",
      "Die Auswahl zeigt verfügbare E-CARD-Stufen in deinem Budget. Bei physischen Geschenken prüfe Produktpreis und Versandkosten.",
      "Schon bezahlt? Zahlungshilfe öffnen",
      "Geschenkkarten"
    ]
  },
  "en": {
    "o": [
      "Order confirmation missing",
      "House number or address detail missing",
      "Parcel returning to sender",
      "Request an invoice"
    ],
    "g": [
      "Check your spam folder and customer account. The checkout email and approximate date help us investigate. If you already paid, you can also use our payment help.",
      "Tell us the missing house number or address detail and the full correct delivery address. We check whether a correction is still possible. It applies only after our confirmation; this request does not automatically stop dispatch.",
      "Note the return-to-sender tracking message and reason, if known. We check the actual status and next step. This does not yet promise a replacement shipment or refund.",
      "Provide the order and desired invoice details. We will review the request; changes to the original invoice details are not yet confirmed."
    ],
    "f": [
      "Email used at checkout (if different)",
      "Approximate order date (if known)",
      "Return reason in tracking (if known)",
      "Requested invoice details (optional)",
      "Company / VAT number (if relevant)",
      "Brand of the requested product (optional)",
      "We collect your wish for our range. This does not promise sourcing or availability."
    ],
    "u": [
      "Find a product",
      "Product name or brand",
      "Search the shop",
      "Find help quickly",
      "For example: address, brush, invoice",
      "No matching topic found. Choose product or order help below.",
      "Enter at least two characters.",
      "Find a gift by budget",
      "Your maximum budget",
      "Checking available E-CARD amounts …",
      "No available E-CARD amount is currently listed within this budget.",
      "View a matching E-CARD",
      "Browse products within budget",
      "Find a beauty gift by colour",
      "Send a gift directly",
      "Delivery address: recipient’s full name, street, house number, postcode, city and country.",
      "Choose voucher type: digital E-CARD by email or a physical voucher for postal delivery.",
      "Personal message: check whether the selected product or checkout offers a field for it.",
      "Before paying, check recipient details, shipping costs and displayed delivery information.",
      "This shows available E-CARD amounts within your budget. For physical gifts, check product price and shipping costs.",
      "Already paid? Open payment help",
      "Gift cards"
    ]
  },
  "fr": {
    "o": [
      "Confirmation de commande manquante",
      "Numéro ou complément d’adresse manquant",
      "Colis retourné à l’expéditeur",
      "Demander une facture"
    ],
    "g": [
      "Vérifiez les spams et votre compte client. L’e-mail utilisé à l’achat et la date approximative nous aident à vérifier. Si vous avez payé, utilisez aussi l’aide au paiement.",
      "Indiquez le numéro ou complément manquant et l’adresse complète correcte. Nous vérifions si une correction reste possible. Elle nécessite notre confirmation ; la demande ne bloque pas automatiquement l’envoi.",
      "Notez le message de retour et le motif dans le suivi, si connu. Nous vérifierons la situation et la suite. Cela ne promet pas encore de réexpédition ni de remboursement.",
      "Indiquez la commande et les coordonnées souhaitées pour la facture. Nous examinerons la demande ; la modification des données d’origine n’est pas encore confirmée."
    ],
    "f": [
      "E-mail utilisé à l’achat (si différent)",
      "Date approximative de commande (si connue)",
      "Motif de retour dans le suivi (si connu)",
      "Coordonnées de facturation souhaitées (facultatif)",
      "Société / numéro de TVA (si pertinent)",
      "Marque du produit souhaité (facultatif)",
      "Nous recueillons votre souhait pour notre assortiment, sans promesse d’approvisionnement ni de disponibilité."
    ],
    "u": [
      "Trouver un produit",
      "Nom du produit ou marque",
      "Rechercher dans la boutique",
      "Trouver de l’aide",
      "Par exemple : adresse, pinceau, facture",
      "Aucun sujet trouvé. Choisissez l’aide produit ou commande ci-dessous.",
      "Saisissez au moins deux caractères.",
      "Trouver un cadeau selon le budget",
      "Votre budget maximum",
      "Recherche des montants E-CARD disponibles …",
      "Aucun montant E-CARD disponible ne correspond actuellement à ce budget.",
      "Voir une E-CARD adaptée",
      "Voir les produits dans ce budget",
      "Trouver un cadeau beauté par couleur",
      "Envoyer un cadeau directement",
      "Adresse : nom complet, rue, numéro, code postal, ville et pays du destinataire.",
      "Choisissez une E-CARD numérique par e-mail ou un bon physique envoyé par la poste.",
      "Message personnel : vérifiez si le produit ou le paiement propose un champ prévu.",
      "Avant de payer, vérifiez le destinataire, les frais et les informations de livraison affichées.",
      "Les montants E-CARD disponibles respectent votre budget. Pour les cadeaux physiques, vérifiez le prix et les frais de livraison.",
      "Déjà payé ? Aide au paiement",
      "Cartes cadeaux"
    ]
  },
  "it": {
    "o": [
      "Manca la conferma d’ordine",
      "Manca numero civico o dettaglio indirizzo",
      "Pacco in ritorno al mittente",
      "Richiedere una fattura"
    ],
    "g": [
      "Controlla spam e account cliente. L’email usata all’acquisto e la data approssimativa ci aiutano a verificare. Se hai già pagato, usa anche l’aiuto per i pagamenti.",
      "Indica il numero civico o dettaglio mancante e l’indirizzo completo corretto. Verifichiamo se è ancora possibile correggerlo. Serve la nostra conferma; la richiesta non ferma automaticamente la spedizione.",
      "Annota il messaggio di ritorno nel tracking e il motivo, se noto. Verificheremo lo stato e il passo successivo. Non è ancora una promessa di nuova spedizione o rimborso.",
      "Indica l’ordine e i dati desiderati per la fattura. Valuteremo la richiesta; la modifica dei dati originali non è ancora confermata."
    ],
    "f": [
      "Email usata all’acquisto (se diversa)",
      "Data approssimativa dell’ordine (se nota)",
      "Motivo del ritorno nel tracking (se noto)",
      "Dati di fatturazione richiesti (facoltativo)",
      "Azienda / partita IVA (se pertinente)",
      "Marca del prodotto desiderato (facoltativo)",
      "Raccogliamo il desiderio per il nostro assortimento, senza promettere approvvigionamento o disponibilità."
    ],
    "u": [
      "Trova un prodotto",
      "Nome del prodotto o marca",
      "Cerca nel negozio",
      "Trova aiuto",
      "Per esempio: indirizzo, pennello, fattura",
      "Nessun argomento trovato. Scegli sotto l’aiuto per prodotti o ordini.",
      "Inserisci almeno due caratteri.",
      "Trova un regalo per budget",
      "Il tuo budget massimo",
      "Controllo gli importi E-CARD disponibili …",
      "Nessun importo E-CARD disponibile rientra attualmente nel budget.",
      "Vedi una E-CARD adatta",
      "Vedi prodotti entro il budget",
      "Trova un regalo beauty per colore",
      "Spedisci un regalo direttamente",
      "Indirizzo: nome completo, via, numero civico, CAP, città e paese del destinatario.",
      "Scegli una E-CARD digitale via email o un buono fisico da spedire per posta.",
      "Messaggio personale: verifica se il prodotto o il checkout offre un campo apposito.",
      "Prima di pagare controlla destinatario, costi e informazioni di consegna mostrate.",
      "Gli importi E-CARD disponibili rientrano nel budget. Per regali fisici, controlla prezzo e spese di spedizione.",
      "Hai già pagato? Apri l’aiuto pagamenti",
      "Buoni regalo"
    ]
  },
  "es": {
    "o": [
      "Falta la confirmación del pedido",
      "Falta número o detalle de dirección",
      "Paquete de vuelta al remitente",
      "Solicitar factura"
    ],
    "g": [
      "Revisa spam y cuenta de cliente. El correo de compra y la fecha aproximada nos ayudan a comprobarlo. Si ya pagaste, usa también la ayuda de pagos.",
      "Indica el número o detalle que falta y la dirección completa correcta. Comprobaremos si aún se puede corregir. Requiere nuestra confirmación; la solicitud no detiene automáticamente el envío.",
      "Anota el mensaje de devolución y el motivo en el seguimiento, si lo sabes. Revisaremos el estado y el siguiente paso. Aún no se promete reenvío ni reembolso.",
      "Indica el pedido y los datos deseados para la factura. Revisaremos la solicitud; el cambio de los datos originales aún no está confirmado."
    ],
    "f": [
      "Correo usado al comprar (si es distinto)",
      "Fecha aproximada del pedido (si la sabes)",
      "Motivo de devolución en el seguimiento (si lo sabes)",
      "Datos de facturación solicitados (opcional)",
      "Empresa / número de IVA (si procede)",
      "Marca del producto deseado (opcional)",
      "Recogemos tu deseo para nuestro surtido, sin prometer adquisición ni disponibilidad."
    ],
    "u": [
      "Encontrar un producto",
      "Nombre del producto o marca",
      "Buscar en la tienda",
      "Encontrar ayuda",
      "Por ejemplo: dirección, pincel, factura",
      "No hay temas coincidentes. Elige abajo ayuda de productos o pedidos.",
      "Escribe al menos dos caracteres.",
      "Encontrar regalo por presupuesto",
      "Tu presupuesto máximo",
      "Buscando importes E-CARD disponibles …",
      "Actualmente no hay un importe E-CARD disponible dentro de este presupuesto.",
      "Ver una E-CARD adecuada",
      "Ver productos dentro del presupuesto",
      "Encontrar regalo beauty por color",
      "Enviar un regalo directamente",
      "Dirección: nombre completo, calle, número, código postal, ciudad y país del destinatario.",
      "Elige E-CARD digital por correo o vale físico para envío postal.",
      "Mensaje personal: comprueba si el producto o el pago ofrece un campo para ello.",
      "Antes de pagar, revisa destinatario, gastos e información de entrega mostrada.",
      "Los importes E-CARD disponibles se ajustan al presupuesto. Para regalos físicos, revisa precio y gastos de envío.",
      "¿Ya pagaste? Abrir ayuda de pagos",
      "Tarjetas regalo"
    ]
  },
  "pl": {
    "o": [
      "Brak potwierdzenia zamówienia",
      "Brakuje numeru domu lub części adresu",
      "Paczka wraca do nadawcy",
      "Poprosić o fakturę"
    ],
    "g": [
      "Sprawdź spam i konto klienta. E-mail użyty przy zakupie i przybliżona data pomogą nam sprawdzić sprawę. Jeśli zapłacono, możesz też skorzystać z pomocy dotyczącej płatności.",
      "Podaj brakujący numer lub element adresu oraz pełny poprawny adres dostawy. Sprawdzimy, czy korekta jest jeszcze możliwa. Wymaga naszego potwierdzenia; zgłoszenie nie zatrzymuje wysyłki.",
      "Zapisz komunikat o zwrocie i powód w śledzeniu, jeśli znany. Sprawdzimy stan i następny krok. Nie jest to jeszcze obietnica ponownej wysyłki ani zwrotu pieniędzy.",
      "Podaj zamówienie i żądane dane do faktury. Sprawdzimy zgłoszenie; zmiana pierwotnych danych nie jest jeszcze potwierdzona."
    ],
    "f": [
      "E-mail użyty przy zakupie (jeśli inny)",
      "Przybliżona data zamówienia (jeśli znana)",
      "Powód zwrotu w śledzeniu (jeśli znany)",
      "Żądane dane do faktury (opcjonalnie)",
      "Firma / numer VAT (jeśli dotyczy)",
      "Marka wymarzonego produktu (opcjonalnie)",
      "Zbieramy życzenia dotyczące oferty, bez obietnicy sprowadzenia lub dostępności."
    ],
    "u": [
      "Znajdź produkt",
      "Nazwa produktu lub marka",
      "Szukaj w sklepie",
      "Szybko znajdź pomoc",
      "Na przykład: adres, pędzel, faktura",
      "Nie znaleziono tematu. Wybierz poniżej pomoc produktową lub dotyczącą zamówień.",
      "Wpisz co najmniej dwa znaki.",
      "Znajdź prezent według budżetu",
      "Twój maksymalny budżet",
      "Sprawdzam dostępne kwoty E-CARD …",
      "Obecnie brak dostępnej kwoty E-CARD w tym budżecie.",
      "Zobacz pasującą E-CARD",
      "Zobacz produkty w budżecie",
      "Znajdź prezent beauty według koloru",
      "Wyślij prezent bezpośrednio",
      "Adres: pełne imię i nazwisko, ulica, numer, kod pocztowy, miasto i kraj odbiorcy.",
      "Wybierz cyfrową E-CARD e-mailem lub fizyczny bon wysyłany pocztą.",
      "Osobista wiadomość: sprawdź, czy produkt lub kasa oferuje odpowiednie pole.",
      "Przed zapłatą sprawdź odbiorcę, koszty i wyświetlane informacje o dostawie.",
      "Dostępne kwoty E-CARD mieszczą się w budżecie. Przy fizycznych prezentach sprawdź cenę i koszt wysyłki.",
      "Już zapłacono? Otwórz pomoc płatności",
      "Karty podarunkowe"
    ]
  },
  "sv": {
    "o": [
      "Orderbekräftelse saknas",
      "Husnummer eller adressdetalj saknas",
      "Paketet går tillbaka till avsändaren",
      "Begär faktura"
    ],
    "g": [
      "Kontrollera skräppost och kundkonto. E-postadressen vid köpet och ungefärligt datum hjälper oss att kontrollera. Har du betalat kan du även använda betalningshjälpen.",
      "Ange saknat nummer eller adressuppgift och fullständig korrekt leveransadress. Vi kontrollerar om ändring är möjlig. Vår bekräftelse krävs; förfrågan stoppar inte leveransen automatiskt.",
      "Notera returmeddelandet och orsaken i spårningen, om känd. Vi kontrollerar status och nästa steg. Det lovar ännu inte en ny leverans eller återbetalning.",
      "Ange beställning och önskade fakturauppgifter. Vi granskar förfrågan; ändring av ursprungliga uppgifter är inte bekräftad."
    ],
    "f": [
      "E-post vid köpet (om annan)",
      "Ungefärligt beställningsdatum (om känt)",
      "Returorsak i spårningen (om känd)",
      "Önskade fakturauppgifter (valfritt)",
      "Företag / momsnummer (om relevant)",
      "Märke för önskad produkt (valfritt)",
      "Vi samlar önskemål för sortimentet utan löfte om inköp eller tillgänglighet."
    ],
    "u": [
      "Hitta en produkt",
      "Produktnamn eller märke",
      "Sök i butiken",
      "Hitta hjälp snabbt",
      "Till exempel: adress, borste, faktura",
      "Inget ämne hittades. Välj produkt- eller beställningshjälp nedan.",
      "Ange minst två tecken.",
      "Hitta present efter budget",
      "Din högsta budget",
      "Kontrollerar tillgängliga E-CARD-belopp …",
      "Inget tillgängligt E-CARD-belopp finns inom budgeten just nu.",
      "Se ett passande E-CARD",
      "Se produkter inom budgeten",
      "Hitta skönhetspresent efter färg",
      "Skicka present direkt",
      "Leveransadress: mottagarens fullständiga namn, gata, nummer, postnummer, ort och land.",
      "Välj digitalt E-CARD via e-post eller fysiskt presentkort med post.",
      "Personligt meddelande: kontrollera om produkten eller kassan har ett fält för det.",
      "Kontrollera mottagare, fraktkostnad och visad leveransinformation före betalning.",
      "Tillgängliga E-CARD-belopp ryms i budgeten. För fysiska presenter, kontrollera pris och frakt.",
      "Redan betalat? Öppna betalningshjälp",
      "Presentkort"
    ]
  },
  "fi": {
    "o": [
      "Tilausvahvistus puuttuu",
      "Talonumero tai osoitetieto puuttuu",
      "Paketti palautuu lähettäjälle",
      "Pyydä laskua"
    ],
    "g": [
      "Tarkista roskaposti ja asiakastili. Ostossa käytetty sähköposti ja arvioitu päivä auttavat selvityksessä. Jos olet maksanut, voit käyttää myös maksuapua.",
      "Kerro puuttuva numero tai osoitetieto ja koko oikea toimitusosoite. Tarkistamme, voiko sen vielä korjata. Vahvistuksemme tarvitaan; pyyntö ei pysäytä lähetystä automaattisesti.",
      "Kirjaa seurannan palautusviesti ja syy, jos tiedossa. Tarkistamme tilan ja seuraavan vaiheen. Tämä ei vielä lupaa uutta lähetystä tai hyvitystä.",
      "Kerro tilaus ja toivotut laskutustiedot. Tarkistamme pyynnön; alkuperäisten tietojen muutosta ei ole vielä vahvistettu."
    ],
    "f": [
      "Ostossa käytetty sähköposti (jos eri)",
      "Arvioitu tilauspäivä (jos tiedossa)",
      "Palautuksen syy seurannassa (jos tiedossa)",
      "Toivotut laskutustiedot (valinnainen)",
      "Yritys / ALV-tunnus (tarvittaessa)",
      "Toivotun tuotteen merkki (valinnainen)",
      "Keräämme valikoimatoiveita lupaamatta hankintaa tai saatavuutta."
    ],
    "u": [
      "Etsi tuote",
      "Tuotteen nimi tai merkki",
      "Hae kaupasta",
      "Löydä apu nopeasti",
      "Esimerkiksi: osoite, sivellin, lasku",
      "Aihetta ei löytynyt. Valitse alta tuote- tai tilausapu.",
      "Kirjoita vähintään kaksi merkkiä.",
      "Etsi lahja budjetin mukaan",
      "Enimmäisbudjettisi",
      "Tarkistan saatavilla olevia E-CARD-summia …",
      "Tähän budjettiin sopivaa E-CARD-summaa ei ole nyt saatavilla.",
      "Katso sopiva E-CARD",
      "Katso budjettiin sopivia tuotteita",
      "Etsi kauneuslahja värien avulla",
      "Lähetä lahja suoraan",
      "Osoite: vastaanottajan koko nimi, katu, talonumero, postinumero, kaupunki ja maa.",
      "Valitse digitaalinen E-CARD sähköpostilla tai fyysinen lahjakortti postitse.",
      "Henkilökohtainen viesti: tarkista, tarjoaako tuote tai kassa sille kentän.",
      "Tarkista vastaanottaja, toimituskulut ja näytetyt toimitustiedot ennen maksua.",
      "Saatavilla olevat E-CARD-summat sopivat budjettiin. Fyysisissä lahjoissa tarkista hinta ja toimituskulut.",
      "Jo maksettu? Avaa maksuapu",
      "Lahjakortit"
    ]
  },
  "nl": {
    "o": [
      "Bestelbevestiging ontbreekt",
      "Huisnummer of adresdetail ontbreekt",
      "Pakket gaat retour naar afzender",
      "Factuur aanvragen"
    ],
    "g": [
      "Controleer spam en klantaccount. Het e-mailadres bij aankoop en de geschatte datum helpen ons controleren. Als je al betaalde, kun je ook de betaalhulp gebruiken.",
      "Geef het ontbrekende nummer of adresdetail en het volledige juiste afleveradres. We controleren of correctie nog kan. Onze bevestiging is nodig; de aanvraag stopt de verzending niet automatisch.",
      "Noteer de retourmelding en reden in de tracking, indien bekend. We controleren de status en volgende stap. Dit belooft nog geen nieuwe verzending of terugbetaling.",
      "Geef de bestelling en gewenste factuurgegevens door. We beoordelen de aanvraag; wijziging van de oorspronkelijke gegevens is nog niet bevestigd."
    ],
    "f": [
      "E-mail bij aankoop (indien anders)",
      "Geschatte besteldatum (indien bekend)",
      "Retourreden in tracking (indien bekend)",
      "Gewenste factuurgegevens (optioneel)",
      "Bedrijf / btw-nummer (indien relevant)",
      "Merk van gewenst product (optioneel)",
      "We verzamelen wensen voor ons assortiment zonder inkoop of beschikbaarheid te beloven."
    ],
    "u": [
      "Product vinden",
      "Productnaam of merk",
      "Zoeken in de winkel",
      "Snel hulp vinden",
      "Bijvoorbeeld: adres, kwast, factuur",
      "Geen onderwerp gevonden. Kies hieronder product- of bestelhulp.",
      "Voer minstens twee tekens in.",
      "Cadeau vinden op budget",
      "Je maximale budget",
      "Beschikbare E-CARD-bedragen controleren …",
      "Er is nu geen beschikbaar E-CARD-bedrag binnen dit budget.",
      "Passende E-CARD bekijken",
      "Producten binnen budget bekijken",
      "Beautycadeau vinden op kleur",
      "Cadeau direct versturen",
      "Adres: volledige naam, straat, huisnummer, postcode, plaats en land van de ontvanger.",
      "Kies digitale E-CARD per e-mail of fysieke cadeaubon per post.",
      "Persoonlijk bericht: controleer of product of checkout hiervoor een veld biedt.",
      "Controleer vóór betaling ontvanger, verzendkosten en getoonde bezorginformatie.",
      "Beschikbare E-CARD-bedragen passen in je budget. Controleer bij fysieke cadeaus prijs en verzendkosten.",
      "Al betaald? Open betaalhulp",
      "Cadeaubonnen"
    ]
  }
};
  const budgetErrors = {de:'Die E-CARD-Stufen lassen sich gerade nicht laden. Bitte versuche es erneut.',en:'The E-CARD amounts cannot be loaded right now. Please try again.',fr:'Les montants E-CARD ne peuvent pas être chargés. Réessayez.',it:'Non è possibile caricare gli importi E-CARD. Riprova.',es:'No se pueden cargar los importes E-CARD. Inténtalo de nuevo.',pl:'Nie można teraz wczytać kwot E-CARD. Spróbuj ponownie.',sv:'E-CARD-beloppen kan inte laddas just nu. Försök igen.',fi:'E-CARD-summia ei voi ladata nyt. Yritä uudelleen.',nl:'De E-CARD-bedragen kunnen nu niet worden geladen. Probeer opnieuw.'};
  const locale = root.dataset.locale?.split('-')[0] || 'en';
  const t = translations[locale] || translations.en;
  const q = key => root.querySelector(`[data-advisor-${key}]`);
  const navigate = route => root.dispatchEvent(new CustomEvent('monolith:navigate', {detail:route}));
  const keys = ['confirmation','address','returning','invoice'];
  root.dispatchEvent(new CustomEvent('monolith:register-order', {detail:{cases:keys.map((key,index)=>({key,label:t.o[index],guide:t.g[index]}))}}));
  const host = q('order-requests');
  const groups = {};
  const group = (key, title) => {
    const box = document.createElement('fieldset');
    box.dataset.advisorRequestGroup = key;
    box.hidden = true; box.disabled = true;
    const legend = document.createElement('legend'); legend.textContent = title;
    box.append(legend); host.append(box); groups[key] = box;
    return box;
  };
  const field = (parent, key, labelText, type, name) => {
    const label = document.createElement('label');
    const input = document.createElement(type === 'textarea' ? 'textarea' : 'input');
    input.id = 'monolith-hub-' + key; input.name = 'contact[' + name + ']';
    label.htmlFor = input.id; label.textContent = labelText;
    if (type === 'textarea') { input.rows = 3; input.maxLength = 1500; }
    else { input.type = type; input.maxLength = 150; }
    parent.append(label, input);
    return input;
  };
  const confirmation = group('confirmation', t.o[0]);
  field(confirmation,'checkout-email',t.f[0],'email','Kauf-E-Mail zur Bestellbestaetigung').autocomplete = 'email';
  field(confirmation,'order-date',t.f[1],'date','Ungefaehres Bestelldatum');
  const paid = document.createElement('button'); paid.type = 'button'; paid.className = 'mono-advisors__color-question'; paid.textContent = t.u[20];
  paid.addEventListener('click',()=>navigate({kind:'order',key:'payment'})); confirmation.append(paid);
  const returning = group('returning', t.o[2]);
  field(returning,'return-reason',t.f[2],'text','Ruecksendegrund laut Tracking');
  const invoice = group('invoice', t.o[3]);
  field(invoice,'invoice-details',t.f[3],'textarea','Gewuenschte Rechnungsangaben');
  field(invoice,'company',t.f[4],'text','Firma oder USt-ID');
  root.addEventListener('monolith:case-change',()=>{
    const active = q('photos').dataset.case;
    for (const [key,box] of Object.entries(groups)) { box.hidden = key !== active; box.disabled = key !== active; }
    if (active === 'address') {
      const change = root.querySelector('[data-advisor-request-group="change"]');
      change.hidden = false; change.disabled = false;
      const kind = root.querySelector('#monolith-request-kind');
      if (kind.value !== 'address') { kind.value = 'address'; kind.dispatchEvent(new Event('change',{bubbles:true})); }
    }
  });
  const wishHost = q('wish-field');
  const wishBrandBox = document.createElement('div'); wishBrandBox.hidden = true;
  const wishBrand = field(wishBrandBox,'wish-brand',t.f[5],'text','Marke des Wunschprodukts'); wishBrand.disabled = true;
  const wishNote = document.createElement('p'); wishNote.className = 'mono-advisors__note'; wishNote.textContent = t.f[6];
  wishBrandBox.append(wishNote); wishHost.append(wishBrandBox);
  root.addEventListener('monolith:reset',()=>{wishBrand.value='';});
  root.addEventListener('monolith:wish-change',event=>{
    const visible = event.detail.index === 1;
    wishBrandBox.hidden = !visible; wishBrand.disabled = !visible;
  });
  for (const [key,index] of Object.entries({'shop-search-entry':0,'shop-search-title':0,'shop-search-label':1,'shop-search-submit':2,'help-search-label':3,'budget-title':7,'budget-label':8,'direct-title':14})) q(key).textContent = t.u[index];
  q('help-search').placeholder = t.u[4];
  const shopForm = q('shop-search-form');
  const preview = new URLSearchParams(location.search).get('preview_theme_id');
  if (preview && /^\d+$/.test(preview)) {
    const input = document.createElement('input'); input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = preview; shopForm.append(input);
  }
  for (const text of t.u.slice(15,19)) {
    const label = document.createElement('label'); label.className = 'mono-advisors__check';
    const input = document.createElement('input'); input.type = 'checkbox';
    const span = document.createElement('span'); span.textContent = text;
    label.append(input,span); q('direct-checks').append(label);
  }
  const budgetHint = document.createElement('p'); budgetHint.className = 'mono-advisors__note'; budgetHint.textContent = t.u[19]; q('gift-budget').append(budgetHint);
  const budget = q('budget-select');
  const currency = root.dataset.currency || 'EUR';
  const money = amount => { try { return new Intl.NumberFormat(locale,{style:'currency',currency}).format(amount); } catch { return String(amount); } };
  for (const amount of [25,50,100,150]) {
    const option = document.createElement('option'); option.value = String(amount); option.textContent = money(amount); budget.append(option);
  }
  q('gift-colors-extra').textContent = t.u[13]; q('gift-colors-extra').addEventListener('click',()=>root.querySelector('[data-advisor-gift-colors]').click());
  let cardDataPromise = null;
  const getCards = () => {
    if (!cardDataPromise) cardDataPromise = (async()=>{
      const link = new URL(q('gift-card-open').href);
      if (link.origin !== location.origin) throw new Error('invalid_route');
      link.pathname += '.js'; link.search = ''; link.hash = '';
      const response = await fetch(link.href,{credentials:'same-origin',signal:AbortSignal.timeout(8000)});
      const data = await response.json();
      if (!response.ok || !Array.isArray(data.variants)) throw new Error('gift_card_unavailable');
      return data;
    })().catch(error=>{cardDataPromise=null;throw error;});
    return cardDataPromise;
  };
  const updateBudget = async () => {
    q('budget-card').hidden = true; q('budget-products').hidden = true; q('budget-status').textContent = t.u[9];
    const amount = Number(budget.value);
    if (q('gift-budget').dataset.priceFilter === 'true') {
      const base = new URL(root.dataset.shopRoot || '/',location.origin);
      if (base.origin === location.origin) {
        const link = new URL('collections/all',base);
        link.searchParams.set('filter.v.price.lte',String(amount));
        q('budget-products').href = link.href; q('budget-products').textContent = t.u[12]; q('budget-products').hidden = false;
      }
    }
    try {
      const data = await getCards();
      const currentAmount = Number(budget.value);
      const eligible = data.variants.filter(item=>item.available === true && Number(item.price)>0 && Number(item.price)<=currentAmount*100 && /^\d+$/.test(String(item.id))).sort((a,b)=>Number(b.price)-Number(a.price));
      if (!eligible.length) { q('budget-status').textContent = t.u[10]; return; }
      const selected = eligible[0];
      const link = new URL(q('gift-card-open').href); link.searchParams.set('variant',String(selected.id));
      q('budget-card').href = link.href; q('budget-card').textContent = t.u[11] + ' · ' + money(Number(selected.price)/100); q('budget-card').hidden = false;
      q('budget-status').textContent = '';
    } catch { q('budget-status').textContent = budgetErrors[locale] || budgetErrors.en; }
  };
  budget.addEventListener('change',updateBudget);
  q('gift-budget').addEventListener('toggle',()=>{if(q('gift-budget').open)void updateBudget();});
  let catalog = [];
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().replace(/ß/g,'ss');
  const add = (label,route,aliases='')=>catalog.push({label:label.replace(/\s+/g,' ').trim(),route,aliases});
  root.querySelectorAll('[data-advisor-view="menu"] [data-advisor-choice]').forEach(button=>add(button.textContent,{kind:'choice',key:button.dataset.advisorChoice,part:button.dataset.advisorCommunityPart}));
  add(q('budget-title').textContent,{kind:'gift',part:'budget'},'budget');
  add(q('direct-title').textContent,{kind:'gift',part:'direct'});
  add(t.u[21],{kind:'gift'},'giftcard gutschein e-card');
  root.addEventListener('monolith:catalog',event=>{
    for (const item of event.detail.order) add(item.label,{kind:'order',key:item.key},item.key === 'payment' ? 'PayPal Klarna Vorkasse bank transfer' : '');
    event.detail.product.forEach((label,index)=>add(label,{kind:'product',index},index===4?'restock notification':'') );
    event.detail.wish.forEach((label,index)=>add(label,{kind:'wish',index}));
  },{once:true});
  root.dispatchEvent(new CustomEvent('monolith:catalog-request'));
  const search = q('help-search');

})();

